import { FC, ReactNode } from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/svg/info.svg';
import styles from './InfoBox.module.scss';

interface InfoBoxProps {
  title?: string;
  // Accepts nodes so a description can carry inline markup (e.g. <Trans> with bolded values).
  description?: ReactNode;
  icon?: ReactNode;
  customStyle?: React.CSSProperties;
}

const InfoBox: FC<InfoBoxProps> = ({ 
  title, 
  description, 
  icon = <InfoIcon />,
  customStyle
}) => {
  const hasTitle = title && title.trim() !== '';
  const hasDescription = typeof description === 'string'
    ? description.trim() !== ''
    : !!description;
  
  if (!hasTitle && !hasDescription) {
    return null; // Don't render if both are empty
  }

  return (
    <div className={styles.infoBox} style={customStyle}>
      {icon}
      <div className={`${styles.infoContent} ${!hasTitle ? styles.centered : ''}`}>
        {hasTitle && (
          <div className={styles.infoTitle}>
            {title}
          </div>
        )}
        {hasDescription && (
          <div className={styles.infoDescription}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoBox;
